import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { MdOutlineBadge, MdOutlineImage, MdOutlinePerson, MdZoomIn, MdZoomOut } from 'react-icons/md';
import { PreferencesContext } from '../../contexts/PreferencesContext';
import { STORAGE_URL } from '../../variables';
import TableEmptyState from '../ReusableComponents/TableEmptyState';

class Documentos extends Component {
  static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedDocument: null,
      zoom: 1,
    };
  }

  normalizeUrl(value) {
    if (value == null || value === '') return null;
    if (String(value).startsWith('http://') || String(value).startsWith('https://')) return value;
    return `${STORAGE_URL}${value}`;
  }

  openDocument(documentItem) {
    this.setState({ selectedDocument: documentItem, zoom: 1 });
  }

  closeDocument() {
    this.setState({ selectedDocument: null, zoom: 1 });
  }

  changeZoom(delta) {
    this.setState((prevState) => ({
      zoom: Math.min(3, Math.max(1, Number((prevState.zoom + delta).toFixed(2)))),
    }));
  }

  getDocuments() {
    const { candidato = {}, processo_resultado = {} } = this.props;
    const t = this.context.t;
    const locale = this.context.selectedLanguage === 'en' ? 'en-US' : this.context.selectedLanguage === 'es' ? 'es-ES' : 'pt-BR';
    const documents = [];
    const pushDocument = (section, title, url, icon) => {
      const normalizedUrl = this.normalizeUrl(url);
      if (normalizedUrl == null) return;
      documents.push({
        id: `${section}-${documents.length}`,
        section,
        title,
        url: normalizedUrl,
        icon,
      });
    };

    pushDocument(t('candidate_profile_photo'), t('candidate_profile_photo'), candidato.imagem, <MdOutlinePerson />);
    pushDocument(
      t('candidate_acceptance_photo'),
      t('candidate_acceptance_photo'),
      processo_resultado?.photo_url || processo_resultado?.photo,
      <MdOutlineImage />
    );

    const validations = candidato.document_validations
      || candidato.request_validations
      || candidato.request_user_validations
      || [];

    validations.forEach((validation, index) => {
      const date = validation.created_at ? ` - ${new Date(validation.created_at).toLocaleString(locale)}` : '';
      pushDocument(
        t('candidate_document_photos'),
        `${t('face_photo')}${date}`,
        validation.face_photo_url || validation.face_photo_path || validation.face_photo,
        <MdOutlinePerson />
      );
      pushDocument(
        t('candidate_document_photos'),
        `${t('document_photo')}${date}`,
        validation.document_photo_url || validation.document_photo_path || validation.document_photo,
        <MdOutlineBadge />
      );
      pushDocument(
        t('candidate_document_photos'),
        `${t('candidate_document_composition')} ${index + 1}`,
        validation.photo_url || validation.photo_path || validation.photo,
        <MdOutlineImage />
      );
    });

    return documents;
  }

  render() {
    const t = this.context.t;
    const documents = this.getDocuments();

    return (
      <div className="candidate-documents">
        <div className="video-ai-events-header">
          <div>
            <h4 className="header-title">{t('candidate_documents')}</h4>
            <p className="text-muted mb-0">{t('candidate_documents_description')}</p>
          </div>
        </div>

        {documents.length === 0
          ? (
            <TableEmptyState
              title={t('no_candidate_documents')}
              description={t('no_candidate_documents_description')}
              icon="ID"
            />
          )
          : (
            <div className="candidate-documents-grid">
              {documents.map((documentItem) => (
                <button
                  key={documentItem.id}
                  type="button"
                  className="candidate-document-card"
                  onClick={() => this.openDocument(documentItem)}
                >
                  <span className="candidate-document-thumb">
                    <img src={documentItem.url} alt={documentItem.title} />
                  </span>
                  <span className="candidate-document-info">
                    <span className="candidate-document-section">{documentItem.section}</span>
                    <strong>{documentItem.title}</strong>
                    <small>{t('click_to_zoom')}</small>
                  </span>
                </button>
              ))}
            </div>
          )}

        <Modal
          show={this.state.selectedDocument != null}
          onHide={() => this.closeDocument()}
          size="xl"
          centered
          dialogClassName="candidate-document-preview-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.selectedDocument?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="candidate-document-preview-toolbar">
              <Button
                variant="outline-secondary"
                onClick={() => this.changeZoom(-0.25)}
                disabled={this.state.zoom <= 1}
              >
                <MdZoomOut /> {t('zoom_out')}
              </Button>
              <span>{Math.round(this.state.zoom * 100)}%</span>
              <Button
                variant="outline-secondary"
                onClick={() => this.changeZoom(0.25)}
                disabled={this.state.zoom >= 3}
              >
                <MdZoomIn /> {t('zoom_in')}
              </Button>
            </div>
            <div className="candidate-document-preview-canvas">
              {this.state.selectedDocument?.url && (
                <img
                  src={this.state.selectedDocument.url}
                  alt={this.state.selectedDocument.title}
                  style={{ transform: `scale(${this.state.zoom})` }}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Documentos;
